var map = {
	"./badge-cs.svg": 1856,
	"./badge-da.svg": 1123,
	"./badge-de.svg": 7583,
	"./badge-el.svg": 5641,
	"./badge-en.svg": 5163,
	"./badge-es.svg": 526,
	"./badge-et.svg": 2081,
	"./badge-fr.svg": 8022,
	"./badge-hu.svg": 2011,
	"./badge-it.svg": 5901,
	"./badge-ja.svg": 1049,
	"./badge-ko.svg": 6636,
	"./badge-lt.svg": 4886,
	"./badge-lv.svg": 5764,
	"./badge-nl.svg": 2760,
	"./badge-pl.svg": 8138,
	"./badge-pt.svg": 6530,
	"./badge-ro.svg": 9079,
	"./badge-sk.svg": 9000,
	"./badge-sl.svg": 8807,
	"./badge-sv.svg": 4109,
	"./badge-tr.svg": 4944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7544;